import { useParams } from "react-router-dom";
import useCurrentUser from "../../../../../../../../../../hooks/local-storage/use-current-user";
import { DisclosureHost } from "../../../../../../../../../../hooks/use-disclosure";
import { useGetPatient } from "../../../../../../../../../../queries/use-get-patient-uuid";
import { REFERRAL_INITIAL_VALUES } from "../../../../../../../collabration/collaboration-referral-constant";
import UpsertReferral from "../../../../../../../collabration/referrals/UpsertReferral";

const ReferringOutPatientWrapper = ({
  referralDisclosure,
  referralDiagnosisCode,
}: {
  referralDisclosure: DisclosureHost;
  referralDiagnosisCode: { value: string; label: string }[] | undefined;
}) => {
  const { patientId } = useParams();
  const { data: patientData } = useGetPatient(patientId);
  const [me] = useCurrentUser();

  return (
    <UpsertReferral
      referringOutFromEncounter={true}
      title={"Add Referral Out"}
      disclosureHost={referralDisclosure}
      prefillData={{
        ...REFERRAL_INITIAL_VALUES,
        patient: {
          value: patientData?.uuid,
          label: patientData?.firstName + " " + patientData?.lastName,
        },
        referralFrom: {
          value: me?.uuid,
          label: me?.firstName + " " + me?.lastName,
        },
        referralDiagnosisCode: referralDiagnosisCode,
      }}
    />
  );
};

export default ReferringOutPatientWrapper;
